import React from 'react';
import { hooks } from 'mage-i18n';
import { Typography } from '@klarna/bubble-ui';
import { HelpbotLink } from '../HelpbotLink';
const NoCapturedOrdersExplanationBotMessage = () => {
    const t = hooks.useTranslator();
    const link1 = React.createElement(HelpbotLink, { href: '/orders/all' }, t('helpbot.explanations.noCapturedOrdersLink1'));
    return (React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.explanations.noCapturedOrders', { link1 })));
};
export default NoCapturedOrdersExplanationBotMessage;
